// extracted by mini-css-extract-plugin
module.exports = {"playStatus":"_94fc5dc","players":"_ff77ea8","liveRace":"_803dc74","oval":"_4185143","playing":"_2d24627","pulse":"_be8271a","registered":"_896f608"};